<template>
  <SubscriptionContext>
    <RouterView></RouterView>
  </SubscriptionContext>
</template>

<script setup lang="ts">
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import SubscriptionContext from '@/components/deepadmin/subscription/SubscriptionContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.billing.invoice_history',
  },
})

const { permissions } = useAuthorizationContext()
const { selectedOrganization } = useAccountMembershipsContext()

usePageAccess(
  computed(
    () =>
      !permissions.canManageInvoicing ||
      selectedOrganization.value?.resource.verification?.state !== 'verified',
  ),
)
</script>
